import { render, staticRenderFns } from "./lottostatus.vue?vue&type=template&id=2a693fdc&scoped=true&"
import script from "./lottostatus.vue?vue&type=script&lang=js&"
export * from "./lottostatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a693fdc",
  null
  
)

export default component.exports